export const reports = {category: 'BC', reports: [{name:'Direct Sales Web Reporting',description:'Monthly/Weekly report for BCLDB',to:'provinces/BC/reports/ReportsBCDSWR',favourite:false},
                                                  {name:'Annual Packaged Product Movement Summary',description:'',to:'provinces/BC/reports/ReportsAnnualMovement',favourite:false},
                                                      ]};

//export default reports;